"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAlignment = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./MenuStyles.css"));
var options = [
    {
        icon: react_1.default.createElement(icons_1.AlignLeft, null),
        value: "left",
    },
    {
        icon: react_1.default.createElement(icons_1.AlignCenter, null),
        value: "center",
    },
];
var TextAlignment = function (_a) {
    var valuesInSelection = _a.valuesInSelection, onFocusChange = _a.onFocusChange, onValueChange = _a.onValueChange;
    return (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Auto, padding: "none", button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.AlignLeft, null) })); } },
        react_1.default.createElement("div", { onFocus: function (e) { return onFocusChange(e, "alignmentMenu", true); }, onBlur: function (e) { return onFocusChange(e, "alignmentMenu", false); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", padding: "xxs", gap: "xxs" }, options.map(function (o) {
                var isActive = valuesInSelection.has(o.value);
                return (react_1.default.createElement(kaleidoscope_1.IconButton, { key: o.value, className: styles.iconOptionButton, icon: o.icon, onClick: function () { return onValueChange(o.value); }, "aria-pressed": isActive }));
            })))));
};
exports.TextAlignment = TextAlignment;
